import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ConcentUrl } from '../models/concent.model';
import { ApiResponse } from '../models/response.model';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Concent } from '../models/concent.model';
@Injectable({
  providedIn: 'root'
})
export class ConcentService {

  //$stateConcent:BehaviorSubject<>

  constructor(private http: HttpClient) {

  }


  apiConcentUrl(body): Observable<any> {
    return this.http.post<any>(environment.endpointBackend + '/api/consent/url', body).pipe(
      map(
        payload => {
          switch (payload.response_code) {
            case ('40000'):
              return payload
            default:
              return null
          }
        }
      )
    )
  }
}


interface StateResult<T> {
  status: number,
  result: T  
}